import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import auth from '../helper/auth';
import config from '../config';

export const useTosGuard = () => {
    const { user, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const checkTos = async () => {
            if (!isAuthenticated || !user) {
                setChecked(true);
                return;
            }

            // Don't guard the ToS page itself or public pages
            if (location.pathname === '/tos' || location.pathname === '/sign-in' || location.pathname === '/sign-up') {
                setChecked(true);
                return;
            }

            try {
                // We can use a session flag to avoid repeated checks if accepted
                const sessionAccepted = sessionStorage.getItem(`tos_accepted_${user.id}`);
                if (sessionAccepted === 'true') {
                    setChecked(true);
                    return;
                }

                const res = await auth.fetch(`${config.API_BASE_URL}/api/tos/status`);
                if (res.requiresAcceptance) {
                    navigate('/tos?mode=guard', { replace: true });
                } else {
                    sessionStorage.setItem(`tos_accepted_${user.id}`, 'true');
                    setChecked(true);
                }
            } catch (err) {
                console.error('ToS check failed:', err);
                setChecked(true); // Allow through on error to not block UI if API is down?
                // Or: navigate to error? Let's be safe and let them through if API is down.
            }
        };

        checkTos();
    }, [isAuthenticated, user, location.pathname, navigate]);

    return checked;
};
